<ion-header class="ion-no-border ion-header-modal-mobile" *ngIf="isTouch">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="back-modal-btn"
        text=""
        (click)="navigateBack()"
      >
      </ion-back-button>
    </ion-buttons>
    <ion-label>
      {{ data.title }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<ion-content class="filtering-dates-content">
  <div class="modal-calendar">
    <div class="usf-outline-green-date-range">
      <ion-icon class="date-range-icon" name="calendar-outline"></ion-icon>
      <p class="date-range-content">
        {{ 'i18n.common.dateRange' | translate }}
        <span *ngIf="!fromIssueDateStr && !toIssueDateStr" class="date-range"
          >MM/DD/YYYY - MM/DD/YYYY</span
        >
        <span *ngIf="fromIssueDateStr && !toIssueDateStr">
          {{ fromIssueDateStr }} - MM/DD/YYYY
        </span>
        <span *ngIf="fromIssueDateStr && toIssueDateStr">
          {{ fromIssueDateStr }} - {{ toIssueDateStr }}
        </span>
      </p>
    </div>

    <div
      class="date-range-message"
      data-cy="date-range-message"
      *ngIf="message"
      [innerHTML]="message"
    ></div>

    <mat-calendar
      [selected]="selectedRangeValue"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (selectedChange)="selectedDateRangeChange($event)"
    >
    </mat-calendar>
  </div>
</ion-content>
<ion-footer class="ion-footer-modal" *ngIf="isTouch">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="save-modal-btn"
        data-cy="save-modal-btn"
        class="usf-fill-green-dsktp-tblt-modal-button"
        (click)="navigateBack()"
        translate
      >
        {{ 'i18n.common.save' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
